module.exports = __webpack_public_path__ + "img/UN_Women_Spurning09.c283fb2f.gif";